export const ERROR_WAS_RECEIVED = 'ERROR_WAS_RECEIVED';
export const SENT_ERROR_REQ = 'SENT_ERROR_REQ';